import { Component, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

import { TaskViewerComponent } from '../../../shared/components/task-viewer/task-viewer.component';

/**
 * Page wrapper for TaskViewerComponent
 * Simple wrapper that passes route parameters to TaskViewerComponent
 * TaskViewerComponent handles all route parameter reading and processing
 */
@Component({
  selector: 'app-task-viewer-page',
  standalone: true,
  templateUrl: './task-viewer-page.component.html',
  styleUrls: ['./task-viewer-page.component.scss'],
  imports: [CommonModule, TaskViewerComponent]
})
export class TaskViewerPageComponent implements OnDestroy {
  private router = inject(Router);
  private destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Called when TaskViewerComponent emits taskClosed
   */
  onTaskClosed(): void {
    // Navigate back to requests inbox
    this.router.navigate(['/requests/inbox']);
  }

  /**
   * Called when TaskViewerComponent emits taskUpdated
   */
  onTaskUpdated(event: any): void {
    // Can be used for logging, analytics, etc.
    console.log('Task updated:', event);
  }
}
